module.exports = __webpack_public_path__ + "img/curve-2-2.10dcda0c.svg";